export RateQuoteGenerator from './RateQuoteGenerator';



// WEBPACK FOOTER //
// /src/components/RateQuoteGenerator/index.js